import { Alert, AlertProps } from '@mui/material';
import axios from 'axios';
import * as React from 'react';

type Props = AlertProps & {
    error: unknown;
    severity?: 'error' | 'warning' | 'info' | 'success';
};

function parseErrorPayload(error: any) {
    // Direct string error
    if (typeof error === 'string') {
        return error;
    }

    console.log('parseErrorPayload', typeof error, error);

    // General object error handling
    if (typeof error === 'object') {
        const errorMessages: string[] = [];
        const errors = Object.values(error);

        errors.forEach(errorItem => {
            if (typeof errorItem === 'string') {
                errorMessages.push(errorItem);
            } else if (Array.isArray(errorItem)) {
                errorItem.forEach(nestedItem => {
                    if (typeof nestedItem === 'string') {
                        errorMessages.push(nestedItem);
                    }
                });
            } else if (typeof errorItem === 'object') {
                //assume we're dealing with create contact errors here (terrible error models... yeah)
                const createContactError = errorItem as any;
                if (createContactError?.relatedId && createContactError?.error) {
                    errorMessages.push(createContactError.error);
                }
            }
        });

        if (errorMessages.length) {
            return errorMessages;
        }
    }

    // Fallback for unhandled cases
    return 'An unknown error occurred.';
}

//shows an alert error if error is not null
export default function AxiosErrorAlert({
    error,
    severity = 'error',
    prefix = undefined,
    ...props
}: Props) {
    const errorMessage = React.useMemo(() => {
        if (!error) return null;

        //handle direct badRequest string errors, mvc model validation arrays of errors, and objects
        if (axios.isAxiosError(error)) {
            return parseErrorPayload(error.response?.data);
        } else {
            return parseErrorPayload(error);
        }
    }, [error]);

    if (!errorMessage) return null;

    console.log('AxiosErrorAlert', axios.isAxiosError(error), error, errorMessage);

    return (
        <Alert severity={severity} {...props}>
            {!!prefix && prefix}
            {Array.isArray(errorMessage) ? (
                <ul style={{ paddingInlineStart: '16px' }}>
                    {errorMessage.map((message, key) => (
                        <li key={key}>{message}</li>
                    ))}
                </ul>
            ) : (
                errorMessage
            )}
        </Alert>
    );
}
